

import { Trans } from '../plugins/Translation'
import Auth from '../services/auth'


export default {



    printResponse(response) {
        console.log(JSON.stringify(response));
    },

    getResponseForError(response) {
        Trans.currentLanguage = "es"
        response.type = response.message.type;

        if (Trans.currentLanguage == 'en') {
            response.message = response.message.message_en;
        } if (Trans.currentLanguage == 'es') {
            response.message = response.message.message_es;
        }
        return response;
    },


    handleRsponse(response) {
        try {

           // this.printResponse(response);
            if (response.errorCode == 401) {

                Auth.logout().then(() => {
                    window.location.replace("/");
                })


                return response;
                //  window.location.replace(Trans.currentLanguage+"/login")


            } else if (response.errorCode == 0) {
                return response;
            } else {
                response = this.getResponseForError(response);
                if (response.type != 'popup') {
                    this.$toastr['error'](response.message, 'Error');
                } else {
                    response.errorCode = '11'
                }


                return response;
            }
        } catch (error) {
            console.log('Error', error.message)
        }
    },



}
